export enum NotificationStyle {
    Info = "Info", Error = "Error", Success = "Success"
}